import { render, staticRenderFns } from "./SelectPunishment.vue?vue&type=template&id=09bdabb0&scoped=true&"
import script from "./SelectPunishment.vue?vue&type=script&lang=ts&"
export * from "./SelectPunishment.vue?vue&type=script&lang=ts&"
import style0 from "./SelectPunishment.vue?vue&type=style&index=0&id=09bdabb0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09bdabb0",
  null
  
)

export default component.exports